import { UserSecurityProfile } from '@atlassian/cssxp-typescommon';
import { PartnerSearchContext } from '@css-xp/ppc-graphtypes';
import { PartnerGraphContext } from '../graph/context';
import { covertToCCPSearchLowerCase } from '../common/string-util';

export const extractUserSecurityProfile = (graphContext: PartnerGraphContext) => {
  return {
    userContextToken: graphContext.userContext,
    userName: graphContext.user.email,
    atlassianAccountId: graphContext.user.atlassianAccountId,
  } as UserSecurityProfile;
};

const buildQueryWithCustomerAddressContext = (searchTerm: string) => {
  return [
    buildCaseInsensitiveWildcardBlob('postalAddress.line1.keyword', searchTerm),
    buildCaseInsensitiveWildcardBlob('postalAddress.line2.keyword', searchTerm),
    buildCaseInsensitiveWildcardBlob('postalAddress.postcode.keyword', searchTerm),
    buildCaseInsensitiveWildcardBlob('postalAddress.city.keyword', searchTerm),
  ];
};

const buildQueryWithOrganizationContext = (searchTerm: string) => {
  return [buildCaseInsensitiveWildcardBlob('name.keyword', searchTerm)];
};

const buildCaseInsensitiveWildcardBlob = (searchKey: string, searchTerm: string) => {
  return {
    wildcard: {
      [searchKey]: {
        value: '*' + searchTerm + '*',
        case_insensitive: true,
      },
    },
  };
};

const buildQueryWithAllContext = (searchTerm: string) => [
  ...buildQueryWithOrganizationContext(searchTerm),
  ...buildQueryWithCustomerAddressContext(searchTerm),
];

const buildQueryWithSearchTermsAndPartnerContext = (
  searchTerm: string,
  partnerSearchContext?: PartnerSearchContext
) => {
  switch (partnerSearchContext) {
    case PartnerSearchContext.CUSTOMER_ADDRESS:
      return buildQueryWithCustomerAddressContext(searchTerm);
    case PartnerSearchContext.COMPANY:
      return buildQueryWithOrganizationContext(searchTerm);
    case PartnerSearchContext.ALL:
      return buildQueryWithAllContext(searchTerm);
    default:
      throw new Error(
        `search with partner search context type ${partnerSearchContext} not implemented to fetch ship to parties`
      );
  }
};

export const buildShouldQuery = (query?: string, searchContext?: PartnerSearchContext) => {
  if (!query) {
    return [];
  }
  return buildQueryWithSearchTermsAndPartnerContext(query, searchContext as PartnerSearchContext);
};
export const buildShouldQueryEntitlement = (ids?: any) => {
  return [buildCaseInsensitiveWildcardBlob('id.keyword', ids)];
};

export const buildMustQuery = (
  transactionAccountId: string,
  ids?: string[],
  names?: string[],
  allowCaseInsestiveNameSearch?: boolean,
  allowActiveFilter?: boolean
  // eslint-disable-next-line max-params
) => {
  // FIXME :: Refactor this to avoid if and else conditions
  const mustQuery: any[] = [
    { match: { transactionAccountId } },
    ...(allowActiveFilter ? [{ match: { active: true } }] : []),
  ];
  if (ids && ids.length !== 0) {
    mustQuery.push({ terms: { id: ids } });
    return mustQuery;
  }
  if (names && names.length !== 0) {
    if (allowCaseInsestiveNameSearch) {
      mustQuery.push({ terms: { 'name.lowercase': names.map((name) => covertToCCPSearchLowerCase(name)) } });
      return mustQuery;
    }
    mustQuery.push({ terms: { 'name.keyword': names } });
    return mustQuery;
  }
  return mustQuery;
};
export const buildMustQueryEntitlement = (transactionAccountId: string, ids?: string[], names?: string[]) => {
  // FIXME :: Refactor this to avoid if and else conditions
  if (ids && ids.length !== 0) {
    return [{ match: { transactionAccountId } }, { terms: { entitlementId: ids } }];
  }
  return [{ match: { transactionAccountId } }, { terms: { 'name.keyword': names } }];
};

export const buildSearchQuery = (mustQueries: any[], shouldQueries: any[]) => {
  if (shouldQueries.length === 0) {
    return {
      bool: {
        must: mustQueries,
      },
    };
  }
  return {
    bool: {
      must: mustQueries,
      should: shouldQueries,
      minimum_should_match: 1,
    },
  };
};
